var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.presidentialElectionsFirstRoundData
    ? _c(
        "div",
        {
          staticClass: "presidential-elections-first-round",
          class: { container: !_vm.isElectionTag },
        },
        [
          _vm.isElectionTag
            ? [
                _c("div", { staticClass: "wrap-select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedState,
                          expression: "selectedState",
                        },
                      ],
                      staticClass: "states-select",
                      attrs: {
                        name: "states",
                        id: "states",
                        placeholder: "Seleccione un departamento",
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedState = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function ($event) {
                            return _vm.getState(_vm.selectedState)
                          },
                        ],
                      },
                    },
                    _vm._l(
                      _vm.presidentialElectionsFirstRoundData.states,
                      function (state) {
                        return _c(
                          "option",
                          { key: state, domProps: { value: state } },
                          [
                            _vm._v(
                              "\n          " + _vm._s(state) + "\n        "
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "wrap-bulletin" }, [
                  _c("div", { staticClass: "bulletin" }, [
                    _vm._v("\n        AVANCE\n        "),
                    _c("span", {
                      staticClass: "number-bulletin",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.presidentialElectionsFirstRoundData.bulletin
                            .bulletinNumber
                        ),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "current-time",
                    domProps: { innerHTML: _vm._s(_vm.currentTime) },
                  }),
                ]),
              ]
            : [
                _c("div", { staticClass: "general-elections" }, [
                  _c("h3", { staticClass: "heading-title" }, [
                    _vm._v(
                      "\n        Elecciones Presidenciales 2026 - Primera Vuelta\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "wrap-bulletin" }, [
                    _c("div", { staticClass: "bulletin" }, [
                      _vm._v("\n          AVANCE\n          "),
                      _c("span", {
                        staticClass: "number-bulletin",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.presidentialElectionsFirstRoundData.bulletin
                              .bulletinNumber
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "current-time",
                      domProps: { innerHTML: _vm._s(_vm.currentTime) },
                    }),
                  ]),
                ]),
              ],
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "first-col" },
            [
              _vm._l(
                _vm.presidentialElectionsFirstRoundData.candidates.slice(0, 2),
                function (item) {
                  return [
                    _c("div", { staticClass: "card-election-1" }, [
                      _c("img", {
                        attrs: {
                          alt: item.name,
                          title: item.name,
                          src: item.image + "?w=320",
                          height: 210,
                          width: 210,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-candidate" }, [
                        _c("div", {
                          staticClass: "candidate-name",
                          domProps: { innerHTML: _vm._s(item.name) },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "votes" }, [
                          _vm._v("Votos " + _vm._s(_vm.format(item.votes))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "bar" }, [
                          _c("div", {
                            staticClass: "r",
                            style: {
                              width: item.percentage * 100 + "%",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "percentage",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatPercent(item.percentage)
                            ),
                          },
                        }),
                      ]),
                    ]),
                  ]
                }
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrap-second-col" }, [
            _c(
              "div",
              { staticClass: "second-col" },
              [
                _vm._l(
                  _vm.presidentialElectionsFirstRoundData.candidates.slice(
                    2,
                    _vm.isElectionTag ? 14 : 8
                  ),
                  function (item) {
                    return [
                      _c("div", { staticClass: "card-election-2" }, [
                        _c("div", {
                          staticClass: "candidate-name",
                          domProps: { innerHTML: _vm._s(item.name) },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-candidate" }, [
                          _c("div", { staticClass: "poll-results" }, [
                            _c("div", { staticClass: "votes" }, [
                              _c("strong", [_vm._v("Votos")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.format(item.votes)) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "bar" }, [
                              _c("div", {
                                staticClass: "r",
                                style: {
                                  width: item.percentage * 100 + "%",
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("hr", { staticClass: "v" }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "percentage",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.formatPercent(item.percentage)
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ]
                  }
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "third-col" }, [
            _c("div", { staticClass: "card-info c-1" }, [
              _c("div", { staticClass: "row-1" }, [
                _c("div", { staticClass: "percentage" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.formatPercent(
                          _vm.presidentialElectionsFirstRoundData.bulletin
                            .percentageInformedTables
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "informed-tables" }, [
                  _vm._v("Mesas Informadas"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.format(
                        _vm.presidentialElectionsFirstRoundData.bulletin
                          .informedTables
                      )
                    ) +
                    "\n        de\n        " +
                    _vm._s(
                      _vm.format(
                        _vm.presidentialElectionsFirstRoundData.bulletin
                          .totalTables
                      )
                    ) +
                    "\n        mesas informadas\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-info c-2" }, [
              _c("div", { staticClass: "row-1" }, [
                _c("div", { staticClass: "percentage" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.formatPercent(
                          _vm.presidentialElectionsFirstRoundData.bulletin
                            .percentageTotalVotes
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vote" }, [_vm._v("Votación")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.format(
                        _vm.presidentialElectionsFirstRoundData.bulletin
                          .totalVotes
                      )
                    ) +
                    "\n        de\n        " +
                    _vm._s(
                      _vm.format(
                        _vm.presidentialElectionsFirstRoundData.bulletin
                          .potentialVotes
                      )
                    ) +
                    "\n        personas habilitadas\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-info" }, [
              _c("div", { staticClass: "row-1" }, [
                _c("div", { staticClass: "percentage" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.formatPercent(
                          _vm.presidentialElectionsFirstRoundData.bulletin
                            .percentageBlankVotes
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vote" }, [_vm._v("En Blanco")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.format(
                        _vm.presidentialElectionsFirstRoundData.bulletin
                          .blankVotes
                      )
                    ) +
                    "\n        votos\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-info" }, [
              _c("div", { staticClass: "row-1" }, [
                _c("div", { staticClass: "percentage" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.formatPercent(
                          _vm.presidentialElectionsFirstRoundData.bulletin
                            .percentageNullVotes
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vote" }, [_vm._v("Nulos")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.format(
                        _vm.presidentialElectionsFirstRoundData.bulletin
                          .nullVotes
                      )
                    ) +
                    "\n        votos\n      "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.presidentialElectionsUrl && !_vm.isElectionTag
            ? _c("div", { staticClass: "button" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn",
                    attrs: { href: _vm.presidentialElectionsUrl },
                  },
                  [_vm._v("RESULTADOS COMPLETOS")]
                ),
              ])
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "select-icon" }, [
      _c("i", { staticClass: "icon-arrow-left" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }